<cam-input-checkbox
  [input]="this.input"
  [standalone]="true"
  (valueChanged)="this.toggleAll($event)"
></cam-input-checkbox>
